import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, unit, unitTRBL, white } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';

import SpeechMark from '@zego/static/svgs/SpeechMark.svg';

const Container = styled(View)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 8,
  backgroundColor: white,
  height: '460px',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',

  [BREAKPOINTS.medium]: {
    padding: unitTRBL(0, 1),
    margin: unitTRBL(0, 2),
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
});

const TileText = styled(RegularText)({
  fontSize: 22,
  lineHeight: '28px',
  fontWeight: 700,
  marginBottom: unit(2),
});

const BrandIcon = styled.img({
  maxWidth: '50%',
  marginBottom: 'auto',
  paddingTop: unit(3),

  [BREAKPOINTS.medium]: {
    paddingTop: unit(6),
  },
});

interface CarouselTestimonialTileProps {
  image: string;
  alt: string;
  text: string;
  customer: string;
}

export default function CarouselTestimonialTile({
  image,
  alt,
  text,
  customer,
}: CarouselTestimonialTileProps): JSX.Element {
  return (
    <Container>
      <img
        alt="speech mark"
        src={SpeechMark}
        css={{
          width: '35px',
          height: '28px',
          whiteSpace: 'normal',
          marginBottom: unit(2),
        }}
      />
      <TileText>{text}</TileText>
      <Spacer height={unit(2)} />
      <RegularText>{customer}</RegularText>
      <BrandIcon alt={alt} src={image} />
    </Container>
  );
}
